var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg8CompensateMember(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 61,
    viewBox: "0 0 67 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2021_1126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.17334 45.7795H13.0186C13.0186 41.4883 11.7442 36.0006 19.3905 31.7353L27.0368 28.1723C29.6116 26.9759 32.6025 28.5884 33.0186 31.3712C33.2787 33.0097 32.5505 34.6482 31.146 35.5585L25.1382 39.4857C25.1382 44.115 28.9094 47.8602 33.5388 47.8342H36.2696C40.2488 47.7822 44.0979 46.2217 46.9588 43.4388L53.2007 37.379C53.7208 36.8849 54.371 36.5468 55.0992 36.4427C58.2462 35.9226 60.3788 39.5377 58.4282 42.0604L52.9146 49.1606C51.3281 51.2152 49.3255 52.9057 47.0108 54.1281L37.9341 58.9655",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2087 41.5143L60.8212 41.8264C63.9162 42.4246 65.0605 46.2217 62.7978 48.4324L56.842 54.2321C53.5651 57.405 49.1957 59.1996 44.6444 59.1996H6.64697",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.732 3.47457L38.3644 11.8422C36.1401 14.0665 36.1401 17.6728 38.3644 19.8971L46.732 28.2647C48.9563 30.489 52.5626 30.489 54.7869 28.2647L63.1545 19.8971C65.3788 17.6728 65.3788 14.0665 63.1545 11.8422L54.7869 3.47457C52.5626 1.25026 48.9563 1.25026 46.732 3.47457Z",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9185 13.4259V18.3154C45.9185 19.6512 47.0014 20.7341 48.3372 20.7341H53.2266C54.5625 20.7341 55.6454 19.6512 55.6454 18.3154V13.4259C55.6454 12.0901 54.5625 11.0072 53.2266 11.0072H48.3372C47.0014 11.0072 45.9185 12.0901 45.9185 13.4259Z",
    stroke: "#C94B32",
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2021_1126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65.2536,
    height: 60,
    fill: "white",
    transform: "translate(0.873047 0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg8CompensateMember);
export default __webpack_public_path__ + "static/media/8-compensate-member.0f8bc9bf79cdd287d17604294ae219c1.svg";
export { ForwardRef as ReactComponent };